import { useContext } from 'react'
import { getLoanInformationApi } from '../api/api-requests'
import { LoanDetailsContext, ScheduleContext } from '../context'
import { useParams } from 'react-router-dom'
export const useGetApplicationInfo = () => {
  const { id } = useParams();

  const { setLoanDetails } = useContext(LoanDetailsContext)
  const { setScheduleData, setActualInterestRate } = useContext(ScheduleContext)

  const getApplicationInfo = () => {

    getLoanInformationApi(id).then(({ data }) => {
      if (data) {
        const date = new Date(data.loanRepaymentScheduleItems[0].date)

        setScheduleData(data.loanRepaymentScheduleItems)
        setActualInterestRate(data.actualInterestRate)
        setLoanDetails({
          duration: data.duration,
          preferredRepaymentDay: data.preferredRepaymentDay,
          preferredRepaymentMonth: data.preferredRepaymentMonth,
          preferredRepaymentDate: date,
        })
      }
    })
  }

  return { getApplicationInfo }
}
